import { useInjectReducer, useInjectSaga } from "redux-injectors";
import saga from "./saga";
import { reducer } from "./slice";

export default function DashboardInjectors() {
  useInjectReducer({ key: "dashboard", reducer });
  useInjectSaga({ key: "dashboard", saga });
  return null;
}
